import {ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {ILeadModalLeadType} from "../../../lead/types/ILeadModalLeadType";
import {ViewType} from "../../../view_type/ViewType";
import {hitGTMOfferRemoveFromCart} from "./offer/hit_gtm_offer_remove_from_cart";
import {hitGTMPropertyRemoveFromCart} from "./property/hit_gtm_property_remove_from_cart";
import {IGTMEcommerceAddProductData} from "./types/IGTMEcommerceAddProductData";

export const hitGTMEcommerceRemoveFromCart = (params: {
    data: IGTMEcommerceAddProductData;
    viewType: ViewType | null;
    leadType: ILeadModalLeadType;
    sourceSection: ApplicationSourceSection | string;
}) => {
    const propertyData = (params.data.property && params.data.property.detail) || undefined;

    if (propertyData) {
        return hitGTMPropertyRemoveFromCart(params);
    }

    return hitGTMOfferRemoveFromCart(params);
};
import {ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {ILeadModalLeadType} from "../../../lead/types/ILeadModalLeadType";
import {ViewType} from "../../../view_type/ViewType";
import {hitGTMOfferRemoveFromCart} from "./offer/hit_gtm_offer_remove_from_cart";
import {hitGTMPropertyRemoveFromCart} from "./property/hit_gtm_property_remove_from_cart";
import {IGTMEcommerceAddProductData} from "./types/IGTMEcommerceAddProductData";

export const hitGTMEcommerceRemoveFromCart = (params: {
    data: IGTMEcommerceAddProductData;
    viewType: ViewType | null;
    leadType: ILeadModalLeadType;
    sourceSection: ApplicationSourceSection | string;
}) => {
    const propertyData = (params.data.property && params.data.property.detail) || undefined;

    if (propertyData) {
        return hitGTMPropertyRemoveFromCart(params);
    }

    return hitGTMOfferRemoveFromCart(params);
};
